export default __webpack_public_path__ + "static/media/SAL2.5fc617b2.webp";